import React from "react";
import DataComponent from "components/common/DataComponent";
import CommVaultData from "./CommVaultData";
import { useState } from "react";
import { setMaxListeners } from "events";
import { set } from "lodash";
import { Spin } from "antd";
import MasterCommVaultData from "./MasterCommVaultData";
import { useLocation } from 'react-router-dom';
import CommvaultMasterDataComponent from "components/common/CommvaultMasterDataComponent";

const MasterCommVault = () => {

  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const { site_code } = location.state || {};
  const { commserve } = location.state || {};
  const contentStyle = {
    padding: 50,
    background: "rgba(255, 255, 255, 0.7)",
    borderRadius: 4,
  };
  const content = <div style={contentStyle} />;

  return (
    <CommvaultMasterDataComponent>
    <div
      id="site-section"
      style={{
        backgroundColor: "white",
        padding: "40px",
        border: "3px solid #f6f6f6",
        borderRadius: "10px",
      }}
    >
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            backgroundColor: "rgba(255, 255, 255, 0.7)", // Optional: Adds a semi-transparent overlay
          }}
        >
          <Spin
            tip={
              <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                Processing...
              </span>
            }
            size="large"
          >
            {content}
          </Spin>
        </div>
      )}
      <MasterCommVaultData setIsSubmitting={setIsSubmitting} site_code={site_code} Commserve={commserve}/>
      {/* <ActionPage /> */}
    </div>
    </CommvaultMasterDataComponent>
  );
};

export default MasterCommVault;
